/**
 * Object.entries but preserves the types of the keys and values
 */
var objectEntries = function objectEntries(r) {
  return Object.entries(r);
};

export { objectEntries };
